<div class="banner-section forget-banner reset-banner">
    <div class="full-container">
        <div class="banner-img">
            <img src="assets/images/forget-banner-img.jpg" alt="" />
        </div>
        <div class="login-wrap">
            <a href="index.html" class="logo"><img src="assets/images/logo.png" alt="logo" /></a>
            <div class="alert-error" *ngIf="errorMessage">{{errorMessage}}</div>
            <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>
            <div class="alert-warning" *ngIf="warningMessage">{{warningMessage}}</div> 
            <form class="login-form" [formGroup]="resetPassword">
                <h2 class="login-title">Set new password</h2>

                <!-- <div class="input-wrap input-wrap-pass">
                        <span class="input-title">New Password</span>
                        <input type="password" placeholder="" >
                        <span class="eye-icon"></span>
                    </div> -->
                <div class="field-wrap">
                    <div class="form-group active">
                        <input type="password" formControlName="password" placeholder="Enter password">
                    </div>
                    <!-- <a href="javascript:void(0)" class="text-link" [routerLink] = "['/user/login']">Back to login</a> -->
                </div>

                <!-- <div class="input-row input-row-wide">
                    <div class="input-wrap">
                        <span class="input-title">Confirm Password</span>
                        <input type="password" placeholder="" formControlName="confirmPassword">
                    </div>
                </div> -->
                <div class="field-wrap">
                    <div class="form-group">
                        <input type="password" formControlName="confirmPassword" placeholder="Confirm password">
                    </div>
                    <!-- <a href="javascript:void(0)" class="text-link" [routerLink] = "['/user/login']">Back to login</a> -->
                </div>
                <span *ngIf="submitted && passwordMatched" class="msg-text success-text">Password matched !</span>
                <span *ngIf="submitted && !passwordMatched" class="msg-text incorrect-text">Password not matched !</span>
                <div class="group-wrap text-right">
                    <button class="primary-btn login" (click)="UpdateUserProfile()">Save</button>
                </div>
            </form>

            <!-- <span class="msg-text success-text">Password matched !</span>
            <span class="msg-text incorrect-text">Password not matched !</span> -->
            <!-- <div class="popup-links text-right">
                <a href="javascript:void(0)" class="btn btn-dark" (click)="UpdateUserProfile()">Update</a>
            </div> -->
        </div>
    </div>
</div>




<!-- <div class="banner-section forget-banner">
    <div class="full-container">
        <div class="banner-img">
            <img src="assets/images/forget-banner-img.jpg" alt="" />
        </div>
        <div class="login-wrap">
            <a href="index.html" class="logo"><img src="assets/images/logo.png" alt="logo" /></a>
            <form class="login-form" [formGroup]="forgetPassword">
                <h2 class="login-title">Forgot password ?</h2>
                <div class="alert-success" *ngIf="successMessage">{{successMessage}}</div>


                <p class="login-subtitle">Enter the email address you have used to sign up</p>
                <div class="field-wrap">
                    <span class="validation-error text-link"
                        *ngIf="submitted && ( f['email'] && f['email']['errors']&& f['email']['errors'].required)">Please
                        Enter Your User ID</span>
                    <span class="validation-error text-link "
                        *ngIf="submitted && ( f['email'] && f['email']['errors']&& f['email']['errors'].emailDomain)">Please
                        Enter Your User ID</span>
                    <span class="validation-error text-link"
                        *ngIf="submitted && ( f['email'] && f['email']['errors']&& f['email']['errors'].pattern)">The
                        email address must contain at least the @ character</span>
                    <div class="form-group active">


                        <input type="text" formControlName="email" placeholder="User Id"
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                        <span class="field-icn"><img src="assets/images/user-icn.png" alt="user-icn" /></span>
                    </div>
                    
                </div>
                <div class="group-wrap text-right">
                    <button class="primary-btn login" (click)="sendForgetPasswordMail()">Send Email</button>
                </div>
            </form>
        </div>
    </div>
</div> -->